import React, { useRef } from 'react';
import styled from 'styled-components';
import { Button } from '.';
import type { ButtonProps } from '.';
import Icon from '../Icon';
import type { IconProps } from '../Icon';

import theme from '../theme';

type TogglableButtonWithIconProps = ButtonProps & {
  isToggled: boolean;
  iconType: IconProps['type'];
  iconWidth?: IconProps['width'];
  iconHeight?: IconProps['height'];
  iconOffset?: IconProps['offset'];
};

const TogglableButtonWithIcon: React.FC<TogglableButtonWithIconProps> = ({
  isToggled,
  iconType,
  iconWidth,
  iconHeight,
  iconOffset,
  onClick,
  ...props
}) => {
  const toggleButtonRef = useRef<HTMLButtonElement>();

  const onToggleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    toggleButtonRef.current?.blur();
    onClick?.(e);
  };

  return (
    <StyledTogglableButton
      {...props}
      onClick={onToggleClick}
      $isToggled={isToggled}
      ref={toggleButtonRef}
    >
      <Icon
        type={iconType}
        width={iconWidth}
        height={iconHeight}
        offset={iconOffset}
        color={isToggled ? 'blue6' : undefined}
      />
    </StyledTogglableButton>
  );
};

export default TogglableButtonWithIcon;

const StyledTogglableButton = styled(Button)<{ $isToggled: boolean }>`
  && {
    ${props => props.$isToggled && `border-color: ${theme.blue6};`}
  }
`;
